import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-job",
  "use": "icon-job-usage",
  "viewBox": "0 0 30 24",
  "content": "<symbol viewBox=\"0 0 30 24\" id=\"icon-job\"><path fill-rule=\"evenodd\" d=\"M24 2H6a2 2 0 0 0-2 2v16h22V4a2 2 0 0 0-2-2m4 18V4a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v16H0v2a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2v-2zM22 6H8v9h14zM8 4a2 2 0 0 0-2 2v11h18V6a2 2 0 0 0-2-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol